/**
 * Main javascript file for CLIA
 * This file uses revealing module pattern
 */
 
import $ from "jquery";
import gsap from "gsap";
    
var clia = function($) {

	var transitionSpeed = 0.5;

    var init = function() {
	    initialiseGlobal();
    }
    
	
    /*
     * global
     */
    var initialiseGlobal = function() {
		var tl = gsap.timeline()
			.to("article", { opacity: 1, duration: 1 })
			.to(".line1", {opacity: 1, duration: 1}) //wait 2 seconds
			.to(".line2", {opacity: 1, duration: 1})
			.to(".line3", {opacity: 1, duration: 1});
			    
	    gsap.to(".anim", {
		  opacity: 1,
		  delay: 2,
		  stagger: 0.5
		});
    };
        
    return{init:init}//return items that are available outside

}($);

//document ready
$(function() {
	clia.init();
});